export const successHandler = (response) => {
  return response;
};

export const errorHandler = (error) => {
  return error;
};
